import { Component } from 'vue-property-decorator';
import EditorBase from './EditorBase';
import UserApi from '@/apis/user-api';
import { Loading } from 'streamlabs-beaker';

@Component({
  components: {
    SLoading: Loading,
  }
})
export default class KickStreamContainer extends EditorBase {
  get origin(): string {
    return window.location.hostname;
  }

  get channelName(): string {
    return this.userKickAccount.name;
  }
}
